import { protectWithAccountPermissions } from '@routes/-protectWithPermission'
import { withCompanyName } from '@routes/-withCompanyName'
import { createFileRoute } from '@tanstack/react-router'
import { BillingMigrationPage } from 'features/billing'
import { subscriptionsQueryOptions } from 'hooks/api/subscriptions'
import { canViewBillingPermission } from 'hooks/usePermission'

export const Route = createFileRoute('/_authenticated/_layout/settings/billing/migrate')({
  component: BillingMigrationPage,
  loader: ({ context: { queryClient, buildRequest } }) => {
    queryClient.prefetchQuery(subscriptionsQueryOptions(buildRequest, ['usageQuota']))
  },
  head: () => ({
    meta: [
      {
        title: withCompanyName('Migrate billing'),
      },
    ],
  }),
  beforeLoad: protectWithAccountPermissions(canViewBillingPermission),
})
